import BracketOracleDefinition from "./BracketOracle.abi.json";
import ERC20Definition from "./ERC20.abi.json";
import PricingDefinition from "./Pricing.abi.json";
import BracketVaultV2Definition from "./BracketVaultV2.abi.json";
import BracketVaultFactoryV2Definition from "./BracketVaultFactoryV2.abi.json";

export const BracketOracle = BracketOracleDefinition;
export const ERC20 = ERC20Definition;
export const Pricing = PricingDefinition;
export const BracketVaultV2 = BracketVaultV2Definition;
export const BracketVaultFactoryV2 = BracketVaultFactoryV2Definition;
